import { createTheme } from '@mui/material/styles';
import { orange } from '@mui/material/colors';
import { breakpoints } from './breakpoints';
import { typography } from './typography';
import { palette } from './palette';
import { overrides } from './overrides';
import type { ThemePreference } from './themePreference';

export type ThemeMode = ThemePreference;

export const getTheme = (mode: ThemeMode) => {
  const spacingScale = [0, 4, 15, 30, 30, 30];
  const spacing = (factor: number | 'auto' = 1): string => {
    if (factor === 'auto') {
      return 'auto';
    }

    const sign = Math.sign(factor) || 1;
    const absFactor = Math.abs(factor);

    if (Number.isInteger(absFactor) && absFactor < spacingScale.length) {
      return `${sign * spacingScale[absFactor]}px`;
    }

    return `${factor * 4}px`;
  };

  /**
   * Base theme
   * ─────────────────────────────
   * Contains ONLY structural tokens:
   * spacing, typography, breakpoints, status
   * No colors, no mode assumptions
   */
  const baseTheme = createTheme({
    spacing,
    breakpoints,
    typography,
    customMode: mode === 'calm' || mode === 'nature' ? mode : undefined,
    status: {
      danger: orange[500],
    },
  });

  /**
   * Final theme
   * ─────────────────────────────
   * Color is fully delegated to:
   *  - palette(mode) → CSS variables
   *  - component overrides → CSS variables
   */
  const themeWithPalette = createTheme(baseTheme, {
    palette: palette(mode),
  });

  return createTheme(themeWithPalette, {
    components: overrides(themeWithPalette),
  });
};
